import React from "react";
import {
  Divider,
  Grid,
  Typography
} from "@mui/material";
import SimpleText from "../../../../../../components/Shared/SimpleText";

const CondoBoletoConfig = ({
    condoData,
    setCondoData,
    error
  }) => {

  return (
    <>
      <Divider sx={{ mb: 3, mt: 5 }} textAlign={'center'}>
        <Typography variant={'h6'}>
          {'Boleto'}
        </Typography>
      </Divider>
      <Grid container spacing={2} rowSpacing={3}>
        <Grid item xs={12}>
          <SimpleText
            label={'Descrição do Boleto'}
            state={condoData}
            setState={setCondoData}
            keyName={'description'}
            error={error}
            isLoading={!condoData}
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default CondoBoletoConfig
